import React, { useState, useEffect } from "react";
import { checkResult, createSelectOption } from "@/common";
import { Upload, ImgContainer } from "@/components";
import { useWatchState, setState } from "@/store";
import { BaseService, uploadUrl } from "@/service";
import { Modal, message, Button, Form, Input, Select, Row, Col } from "antd";

const NAME = "projectEditExpert";

const App = Form.create({ name: 'register' })((props) => {
    const { getFieldDecorator } = props.form;
    const [loading, setLoading] = useState(false);
    const [[modalProps, setProps]] = useWatchState(["modal." + NAME])
    const { show, hide, width = 800, id, callback, UPLOAD_SERVER_HOST } = modalProps;
    const [data, setData] = useState([]);

    const formItemLayout = {
        labelCol: { span: 4 },
        wrapperCol: { span: 19 },
    };

    const getExpertDetail = id => {
        BaseService.list({
            table: "thtt_project_recommend",
            where: {
                id: id,
                "is_delete": 0,
            },
        }).then(res => {
            if (!checkResult(res)) return;
            const data = res.data.result[0];
            setData(data);
        })
    }

    useEffect(() => {
        if (id) getExpertDetail(id)
    }, [id])

    const onSubmit = async (e) => {
        e.preventDefault();
        props.form.validateFieldsAndScroll(async (err, values) => {
            if (id !== 0) {
                if (!err) {
                    setLoading(true);
                    const res = await BaseService.put({
                        table: "thtt_project_recommend", data: {
                            org_name: values.org_name,
                            org_contacts_name: values.org_contacts_name,
                            area: values.area,
                            duties: values.duties,
                            profile: values.profile,
                            photos: values.photos,
                            sex: values.sex,
                            org_contacts_phone: values.org_contacts_phone,
                        }, where: { id: id }
                    });
                    setLoading(false);
                    if (!checkResult(res)) return;
                    message.success("修改成功！");
                    if (callback) callback(res.data.result.id);
                    hide();
                }
            }
            if (id === 0) {
                if (!err) {
                    setLoading(true);
                    const res = await BaseService.add({
                        table: "thtt_project_recommend", data: {
                            org_name: values.org_name,
                            org_contacts_name: values.org_contacts_name,
                            area: values.area,
                            duties: values.duties,
                            profile: values.profile,
                            photos: values.photos,
                            sex: values.sex,
                            org_contacts_phone: values.org_contacts_phone,
                            identify: 3,
                        }
                    });
                    setLoading(false);
                    if (!checkResult(res)) return;
                    message.success("添加成功！");
                    hide();
                    if (callback) callback();
                }
            }
        });
    }
    const onUploadFinish = (e) => {
        const url = e.file.response.files[0].url;
        data.photos = url;
        setState("modal." + NAME + ".data", { ...data });
    }

    return (
        <Modal
            visible={show}
            width={width}
            maskClosable={false}
            destroyOnClose
            onCancel={hide}
            footer={false}
        >
            <Form {...formItemLayout} onSubmit={onSubmit}>
                <div style={{ border: "1px solid #d9d9d9" }}>
                    <div style={{ textAlign: "center", backgroundColor: "#fafafa", marginBottom: 30, height: 50, borderBottom: "1px solid #d9d9d9" }}>
                        <h2>{(id !== 0) ? '修改专家信息' : '新增专家'}</h2>
                    </div>
                    <div style={{ marginLeft: 40 }}>
                        <Row gutter={24} type="flex">
                            <Col span={6}>
                                <Form.Item label="姓名" type="flex" style={{ width: 300 }}>
                                    {
                                        (getFieldDecorator('org_contacts_name', {
                                            initialValue:
                                                [(id !== 0) ? data.org_contacts_name : ""],
                                            rules: [
                                                {
                                                    required: true,
                                                    message: '请输入专家姓名',
                                                },
                                            ],
                                        }
                                        )(<Input placeholder="请输入专家姓名" style={{ width: 100 }} />))
                                    }
                                </Form.Item>
                            </Col>
                            <Col span={6}>
                                <Form.Item label="性别" type="flex" style={{ width: "300px" }}>
                                    {(getFieldDecorator('sex', {
                                        initialValue:
                                            [(id !== 0) ? String(data["sex"]) : ""],
                                        rules: [
                                            {
                                                required: true,
                                                message: '选择请性别',
                                            },
                                        ],
                                    })
                                        (<Select placeholder="-请选择-" style={{ width: "100px" }}>
                                            {createSelectOption([
                                                { label: "-请选择-", value: "" },
                                                { label: "-男-", value: "1" },
                                                { label: "-女-", value: "2" },

                                            ])}
                                        </Select>)
                                    )
                                    }
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item label="联系方式" type="flex" style={{ width: "500px" }}>
                                    {getFieldDecorator('org_contacts_phone', {
                                        initialValue:
                                            [(id !== 0) ? data.org_contacts_phone : ""],
                                        rules: [
                                            {
                                                required: true,
                                                message: '请输入联系方式',
                                            },
                                        ],
                                    })
                                        (<Input placeholder="请输入联系方式" style={{ width: 200 }} />)}
                                </Form.Item></Col>
                        </Row>
                        <Row gutter={24} type="flex">
                            <Col span={12}>
                                <Form.Item label="领域背景" type="flex" style={{ width: 500 }}>
                                    {
                                        (getFieldDecorator('area', {
                                            initialValue:
                                                [(id !== 0) ? data.area : ""],
                                            rules: [
                                                {
                                                    required: true,
                                                    message: '请输入领域背景',
                                                },
                                            ],
                                        }
                                        )(<Input placeholder="请输入领域背景" style={{ width: 200 }} />))
                                    }
                                </Form.Item></Col>

                            <Col span={12}>
                                <Form.Item label="职务" type="flex" style={{ width: 500 }}>
                                    {(getFieldDecorator('duties', {
                                        initialValue:
                                            [(id !== 0) ? String(data["duties"]) : ""],
                                        rules: [
                                            {
                                                required: true,
                                                message: '选择请性别',
                                            },
                                        ],
                                    })
                                        (<Select placeholder="-请选择-" style={{ width: "200px" }}>
                                            {createSelectOption([
                                                { label: "-请选择-", value: "" },
                                                { label: "主任委员", value: "1" },
                                                { label: "副主任委员", value: "2" },
                                                { label: "特聘专家", value: "3" },
                                                { label: "委员", value: "4" },
                                            ])}
                                        </Select>)
                                    )
                                    }
                                </Form.Item></Col>
                        </Row>
                        <Form.Item label="专家单位名称" type="flex" style={{ width: 720 }}>
                            {
                                (getFieldDecorator('org_name', {
                                    initialValue:
                                        [(id !== 0) ? data.org_name : ""],
                                    rules: [
                                        {
                                            required: true,
                                            message: '请输入专家单位名称',
                                        },
                                    ],
                                }
                                )(<Input placeholder="请输入专家单位名称" style={{ width: 530 }} />))
                            }
                        </Form.Item>
                        <Form.Item label="专家简介" type="flex" style={{ width: 720 }}>
                            {
                                (getFieldDecorator('profile', {
                                    initialValue:
                                        [(id !== 0) ? data.profile : ""],
                                    rules: [
                                        {
                                            required: true,
                                            message: '请输入专家简介',
                                        },
                                    ],
                                }
                                )(<textarea rows={5} type="text" placeholder="请输入专家简介" style={{ width: 530, border: "1px solid #e8e8e8", paddingLeft: 5 }} />))
                            }
                        </Form.Item>
                        {/*<Form.Item label="专家照片" required>
                            {getFieldDecorator('photos', {
                                initialValue: data["photos"],
                            })(
                                <Upload
                                    style={{ minWidth: "160px" }}
                                    accept=".jpg,.jpeg,.png"
                                    name="files"
                                    listType="picture-card"
                                    showUploadList={false}
                                    onFinish={onUploadFinish}
                                    action={uploadUrl}
                                >
                                    {data["photos"]
                                        ? <ImgContainer
                                            src={data["photos"]}
                                            width={150}
                                        />
                                        : "上传专家照片"}
                                </Upload>
                            )}
                        </Form.Item>*/}
                        <p style={{ textAlign: "center", marginTop: 50, marginBottom: 20 }}>
                            <Button type="primary" onClick={onSubmit} loading={loading}>{(id !== 0) ? '修改' : '新增'}</Button>
                            <Button onClick={hide} style={{ marginLeft: 20 }}>取消</Button>
                        </p>
                    </div>
                </div>
            </Form>
        </Modal>
    );
})

export default App;